var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupabaseLogoDcc676Ffe2Seeklogocom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.985366 10.9852C0.550447 10.9852 0.199707 10.6345 0.199707 10.1995C0.199707 10.0312 0.255826 9.86282 0.354033 9.73656L0.648655 9.31567L7.45302 0.126266C7.50914 0.0561176 7.59332 0 7.69152 0C7.85988 0 7.98615 0.126267 7.98615 0.294623V0.32268V10.9712H0.985366V10.9852Z",
    fill: "#3ECF8E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0149 7.01483C15.4499 7.01483 15.8006 7.36557 15.8006 7.80049C15.8006 7.96885 15.7445 8.1372 15.6463 8.26347L15.3517 8.68436L8.54729 17.8738C8.49117 17.9439 8.40699 18 8.30878 18C8.14043 18 8.01416 17.8738 8.01416 17.7054V17.6773V7.01483H15.0149Z",
    fill: "url(#paint0_linear_44997_2522)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0149 7.01483C15.4499 7.01483 15.8006 7.36557 15.8006 7.80049C15.8006 7.96885 15.7445 8.1372 15.6463 8.26347L15.3517 8.68436L8.54729 17.8738C8.49117 17.9439 8.40699 18 8.30878 18C8.14043 18 8.01416 17.8738 8.01416 17.7054V17.6773V7.01483H15.0149Z",
    fill: "url(#paint1_linear_44997_2522)",
    fillOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_44997_2522",
    x1: 7.3952,
    y1: 10.8228,
    x2: 13.2059,
    y2: 13.0902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#249361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3ECF8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_44997_2522",
    x1: 7.25333,
    y1: 4.5519,
    x2: 10.154,
    y2: 9.6322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupabaseLogoDcc676Ffe2Seeklogocom);
export default __webpack_public_path__ + "static/media/supabase-logo-DCC676FFE2-seeklogo.com.e0d649d815e316cf404e5ba767a412bc.svg";
export { ForwardRef as ReactComponent };